// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_PP7","cls2":"PaperPreviewList-cls2_ixK PaperPreviewList-cls1_PP7"};